import { useI18n } from '@affine/i18n';
import {
  BookOpenCheckIcon,
  BookOpenIcon,
  BookPlusIcon,
  BookXIcon,
} from '@docnboard/icons/rc';
import { type PostDocsStatusBodyAction } from '@docnboard/rest';
import { useMemo } from 'react';

export type WikiActionConfig = {
  type: PostDocsStatusBodyAction;
  label: string;
  variant?: 'primary' | 'error' | 'secondary';
  menuType?: 'default' | 'danger';
  testId: string;
  icon?: React.ReactElement;
};

export const useWikiActionsConfig = (): WikiActionConfig[] => {
  const t = useI18n();
  return useMemo(
    () => [
      {
        type: 'add',
        label: t['docnboard.wiki.button.add-to-wiki.title'](),
        variant: 'primary',
        testId: 'list-toolbar-add',
        icon: <BookPlusIcon size="1em" />,
      },
      {
        type: 'publish',
        label: t['docnboard.wiki.button.publish-to-wiki.title'](),
        variant: 'primary',
        testId: 'list-toolbar-publish',
        icon: <BookOpenCheckIcon size="1em" />,
      },
      {
        type: 'unpublish',
        label: t['docnboard.wiki.button.unpublish-to-wiki.title'](),
        variant: 'secondary',
        menuType: 'default',
        testId: 'list-toolbar-unpublish',
        icon: <BookOpenIcon size="1em" />,
      },
      {
        type: 'delete',
        label: t['docnboard.wiki.button.delete-from-wiki.title'](),
        variant: 'error',
        menuType: 'danger',
        testId: 'list-toolbar-delete',
        icon: <BookXIcon size="1em" />,
      },
    ],
    [t]
  );
};
